import { ApiRequestPost } from "../../data/network/services/ApiRequestPost";
import { authAction } from "../../data/redux/action/authAction";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../data/redux/action/fullScreenLoadingAction";
import {
  clearIntervalId,
  removeJobAction,
} from "../../data/redux/action/scheduleJobAction";
import { SUCCESS } from "../../presentation/resources/constantsManager";
import { SS_INTERVAL_ID } from "../../presentation/resources/secureStorageManager";
import secureStorage from "../secureStorage";

export const logoutService = (navigate) => (dispatch) => {
  dispatch(startFullScreenLoadingAction());
  ApiRequestPost.logout()
    .then(async (data) => {
      const id = await secureStorage.getItem(SS_INTERVAL_ID);
      clearInterval(id);
      if (data.status === SUCCESS) {
        secureStorage.clear();
        navigate("/login");
        dispatch(authAction(false));
      } else {
        if (data?.message === "User already logged out") {
          secureStorage.clear();
          navigate("/login");
          dispatch(authAction(false));
        }
      }

      dispatch(removeJobAction());
      dispatch(clearIntervalId());
      for (let i = 0; i < 100; i++) {
        window.clearInterval(i);
      }
    })
    .catch((err) => {})
    .finally(() => {
      dispatch(stopFullScreenLoadingAction());
    });
};
